var _filter, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "inset-shadow"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "offset-blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "offset-blur",
    result: "inverse"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "black",
    floodOpacity: 0.95,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color",
    in2: "inverse",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "over",
    in: "shadow",
    in2: "SourceGraphic"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    filter: "url(#inset-shadow)",
    d: "M4.06008 0.5C3.18225 0.5 2.34083 0.82775 1.71983 1.41233C1.41609 1.69351 1.17329 2.03405 1.00647 2.41285C0.839652 2.79166 0.75236 3.20068 0.75 3.61458V20.7458H4.06008C4.06008 21.9839 4.58333 23.1722 5.51675 24.0482C6.47016 24.9325 7.72388 25.4216 9.02425 25.4167C10.341 25.4167 11.6041 24.9241 12.5356 24.0482C12.9917 23.6265 13.3563 23.1156 13.6069 22.5472C13.8574 21.9788 13.9886 21.365 13.9922 20.7438H23.9206C23.9206 21.9839 24.4457 23.1722 25.3772 24.0482C26.3316 24.9334 27.5869 25.4226 28.8886 25.4167C30.2053 25.4167 31.4684 24.9241 32.3999 24.0482C32.8557 23.6264 33.2201 23.1154 33.4703 22.547C33.7205 21.9786 33.8514 21.3649 33.8547 20.7438H37.1667V12.9583L32.2025 6.72917H27.2345V0.5H4.062H4.06008ZM15.6482 3.61458L22.2684 9.84375L15.6482 16.0729V11.4001H5.71417V8.28742H15.6463V3.61267L15.6482 3.61458ZM27.2345 9.06558H31.3745L34.6328 12.9583H27.2345V9.06558ZM9.02617 18.4093C9.6855 18.4093 10.3161 18.6547 10.7818 19.0936C11.2476 19.5306 11.5102 20.1248 11.5102 20.7438C11.5102 21.3648 11.2476 21.959 10.7818 22.396C10.3046 22.8386 9.67701 23.0832 9.02617 23.0803C8.36875 23.0803 7.73625 22.8349 7.2705 22.396C7.04265 22.1854 6.86044 21.9303 6.73516 21.6464C6.60989 21.3626 6.5442 21.056 6.54217 20.7458C6.54217 20.1248 6.80475 19.5306 7.2705 19.0936C7.73625 18.6547 8.36875 18.4093 9.02617 18.4093ZM28.8905 18.4093C29.5479 18.4093 30.1804 18.6547 30.6462 19.0936C31.1119 19.5306 31.3745 20.1248 31.3745 20.7438C31.3745 21.3648 31.1119 21.959 30.6462 22.396C30.169 22.8386 29.5413 23.0832 28.8905 23.0803C28.2312 23.0803 27.6006 22.8349 27.1348 22.396C26.9071 22.1853 26.7249 21.9302 26.5997 21.6464C26.4744 21.3625 26.4086 21.056 26.4065 20.7458C26.4065 20.1248 26.6691 19.5306 27.1348 19.0936C27.6006 18.6547 28.2312 18.4093 28.8905 18.4093Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck1);
export default __webpack_public_path__ + "static/media/truck 1.848a65a9087f29c6fd467ea719e34321.svg";
export { ForwardRef as ReactComponent };